import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;

// In PWA standalone mode, tablets should be treated as mobile (bottom nav etc.)
function isStandalone() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone;
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== 'undefined') {
      const w = window.innerWidth;
      // In PWA standalone: treat tablets (< 1024px) as mobile
      if (isStandalone() && w < TABLET_BREAKPOINT) return true;
      return w < MOBILE_BREAKPOINT;
    }
    return false;
  });

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      if (isStandalone() && w < TABLET_BREAKPOINT) {
        setIsMobile(true);
      } else {
        setIsMobile(w < MOBILE_BREAKPOINT);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}

export function useDeviceType() {
  const [deviceType, setDeviceType] = useState(() => {
    if (typeof window !== 'undefined') {
      const w = window.innerWidth;
      return {
        isMobile: w < MOBILE_BREAKPOINT,
        isTablet: w >= MOBILE_BREAKPOINT && w < TABLET_BREAKPOINT,
        isDesktop: w >= TABLET_BREAKPOINT,
        isTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
      };
    }
    return { isMobile: false, isTablet: false, isDesktop: true, isTouch: false };
  });

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      setDeviceType({
        isMobile: w < MOBILE_BREAKPOINT,
        isTablet: w >= MOBILE_BREAKPOINT && w < TABLET_BREAKPOINT,
        isDesktop: w >= TABLET_BREAKPOINT,
        isTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return deviceType;
}
